import { createFileRoute, Outlet } from '@tanstack/react-router';

import { BrandLogo, useBranding } from '@/shared/branding';
import { LanguageToggle } from '@/shared/components/LanguageToggle';
import { PoweredBy } from '@/shared/components/PoweredBy';

export const Route = createFileRoute('/_public')({
  component: PublicShell,
});

function PublicShell() {
  const branding = useBranding();
  return (
    <div className="flex min-h-screen flex-col bg-canvas">
      <header className="border-b border-border bg-surface">
        {/* Centered wordmark — no admin escape hatch in the public chrome.
            Language switch pinned to the inline-end (flips with RTL). */}
        <div className="relative mx-auto flex w-full max-w-5xl items-center justify-center px-4 py-4 sm:px-6">
          <BrandLogo className="max-h-12 w-auto max-w-[11.5rem] object-contain" />
          <LanguageToggle className="absolute end-4 top-1/2 -translate-y-1/2 sm:end-6" />
        </div>
      </header>

      <main className="flex flex-1 items-start justify-center px-4 py-10 sm:px-6 sm:py-16">
        <div className="w-full max-w-3xl">
          <Outlet />
        </div>
      </main>

      <footer className="border-t border-border bg-surface">
        <div className="mx-auto flex w-full max-w-5xl flex-col items-center gap-1 px-4 py-4 text-xs text-foreground-muted sm:flex-row sm:justify-between sm:px-6">
          <span>
            © {new Date().getFullYear()} {branding.name.en}
          </span>
          <PoweredBy />
        </div>
      </footer>
    </div>
  );
}
